import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { accountTreeModel } from 'entities/account';
import { createPlayerRegistryModel } from 'entities/player';

const playerRegistryModel = createPlayerRegistryModel({
	$currencies: accountTreeModel.$currencies,
	$allAccountIds: accountTreeModel.$nodes.map((nodes) => Object.values(nodes).map(({ id }) => id)),
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: playerRegistryModel.model.filters.accountIds.setValue,
});

chain(playerRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const playersPageModel = {
	playerRegistryModel,
};
